var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6086 8.71075C18.5749 9.72748 18.5749 11.2722 17.6086 12.2889C15.9787 14.0037 13.1796 16.3332 9.99999 16.3332C6.82039 16.3332 4.02123 14.0037 2.39141 12.2889C1.42507 11.2722 1.42507 9.72748 2.39141 8.71075C4.02123 6.99595 6.82039 4.6665 9.99999 4.6665C13.1796 4.6665 15.9787 6.99595 17.6086 8.71075Z",
    stroke: "#575757",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.4998C12.5 11.8805 11.3807 12.9998 9.99999 12.9998C8.61928 12.9998 7.49999 11.8805 7.49999 10.4998C7.49999 9.11913 8.61928 7.99984 9.99999 7.99984C11.3807 7.99984 12.5 9.11913 12.5 10.4998Z",
    stroke: "#575757",
    strokeWidth: 1.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEye);
export default __webpack_public_path__ + "static/media/ic_eye.757dc28c6554a9e975af58ef67c4f739.svg";
export { ForwardRef as ReactComponent };